module.exports = __webpack_public_path__ + "static/img/huaweidcb2.1ebdef6f.png";